var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    _vm._l(_vm.data, function (store, index) {
      return _c("BaseBadge", {
        key: store.value,
        attrs: {
          cyPrefix: `${_vm.cyPrefix}-badge-store-${index}`,
          data: _vm.getNameByIdFromList(store, _vm.selectableStores),
          variant: "secondary",
        },
        on: {
          onDelete: function ($event) {
            return _vm.onDelete(index)
          },
        },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }